@if (socials.length > 0) {

  <section class="social-strip">

    <p class="social-label">
      Follow Us
    </p>

    <div class="social-grid">
      
    @for (social of socials; track $index) {

        <a
          [href]="social.url"
          target="_blank"
          rel="noopener noreferrer"
          class="social-item"
          [style.--brand-color]="social.color"
          [attr.aria-label]="'Visit us on ' + social.name"
        >

          <span class="social-icon">

            @switch (social.key) {

              <!-- FACEBOOK -->

              @case ('facebook') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                  />
                </svg>

              }

              <!-- INSTAGRAM -->

              @case ('instagram') {

                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                  />

                  <circle
                    cx="12"
                    cy="12"
                    r="4"
                  />

                  <circle
                    cx="17.5"
                    cy="6.5"
                    r="1.5"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>

              }

              <!-- TIKTOK -->

              @case ('tiktok') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"
                  />
                </svg>

              }

              <!-- YOUTUBE -->

              @case ('youtube') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"
                  />

                  <polygon
                    points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"
                    fill="white"
                  />
                </svg>

              }

              <!-- X -->

              @case ('x') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                  />
                </svg>

              }

              <!-- THREADS -->

              @case ('threads') {

                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 3c5.2 0 8 3.5 8 8.7 0 5.4-3 9.3-8 9.3-5.2 0-8-3.8-8-9.2C4 6.5 6.9 3 12 3z"
                  />
                  <path
                    d="M8.3 9.3c.8-1.7 2.2-2.6 4-2.6 2.9 0 4.5 1.8 4.5 4.6 0 3.1-1.5 5-3.8 5-1.7 0-2.9-1-2.9-2.5 0-1.6 1.3-2.7 3.3-2.7 1.5 0 2.8.4 4 1.2"
                  />
                </svg>

              }

              <!-- LINKEDIN -->

              @case ('linkedin') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <rect
                    x="3"
                    y="9"
                    width="4"
                    height="12"
                  />
                  <circle
                    cx="5"
                    cy="5"
                    r="2"
                  />
                  <path
                    d="M10 9h4v1.7c.9-1.3 2.2-2.2 4.2-2.2 3.2 0 4.8 2 4.8 5.8V21h-4v-6c0-2-.7-3-2.3-3-1.7 0-2.7 1.1-2.7 3.2V21h-4z"
                  />
                </svg>

              }

              <!-- SNAPCHAT -->

              @case ('snapchat') {

                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 3c-2.9 0-4.7 2.2-4.7 5.2 0 1-.1 1.8-.5 2.4-.5.7-1.3 1-2.2 1.3-.5.2-.6.8-.1 1.1.7.4 1.5.7 2.2.8.2 1 .8 1.8 1.8 2.2-.2.5-.3 1-.2 1.3.2.4.9.2 1.6.1.7-.1 1.1.6 2.1.6s1.4-.7 2.1-.6c.7.1 1.4.3 1.6-.1.1-.3 0-.8-.2-1.3 1-.4 1.6-1.2 1.8-2.2.7-.1 1.5-.4 2.2-.8.5-.3.4-.9-.1-1.1-.9-.3-1.7-.6-2.2-1.3-.4-.6-.5-1.4-.5-2.4C16.7 5.2 14.9 3 12 3z"
                  />
                </svg>

              }

              <!-- PINTEREST -->

              @case ('pinterest') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M12 2a10 10 0 0 0-3.64 19.31c-.09-1.58-.02-3.47.39-5.22l1.29-5.45s-.32-.65-.32-1.61c0-1.51.87-2.64 1.96-2.64.93 0 1.37.7 1.37 1.53 0 .93-.59 2.32-.9 3.61-.26 1.08.54 1.96 1.6 1.96 1.92 0 3.4-2.03 3.4-4.95 0-2.59-1.86-4.4-4.52-4.4-3.08 0-4.89 2.31-4.89 4.7 0 .93.36 1.93.81 2.47.09.11.1.21.08.32l-.3 1.22c-.05.2-.16.24-.37.15-1.39-.65-2.26-2.68-2.26-4.31 0-3.51 2.55-6.73 7.35-6.73 3.86 0 6.86 2.75 6.86 6.42 0 3.83-2.42 6.92-5.77 6.92-1.13 0-2.19-.59-2.55-1.28l-.69 2.64c-.25.97-.93 2.19-1.38 2.93A10 10 0 1 0 12 2z"
                  />
                </svg>

              }

              <!-- BLUESKY -->

              @case ('bluesky') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M12 10.8c-1.4-2.7-5.2-7.7-8.7-10.2C-.1-1.8.5 4.1 1.1 6.8c.7 3 3.1 4 5.4 3.7-4 .6-7.6 2-2.9 7.2 5.1 5.2 7-1.1 8.4-4.3 1.4 3.2 3.3 9.5 8.4 4.3 4.7-5.2 1.1-6.6-2.9-7.2 2.3.3 4.7-.7 5.4-3.7.6-2.7 1.2-8.6-2.2-6.2C17.2 3.1 13.4 8.1 12 10.8z"
                    transform="scale(.85) translate(2.1 2.1)"
                  />
                </svg>

              }

              <!-- REDDIT -->

              @case ('reddit') {

                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle
                    cx="12"
                    cy="13"
                    r="7"
                  />

                  <circle
                    cx="9"
                    cy="12"
                    r="1"
                    fill="currentColor"
                  />

                  <circle
                    cx="15"
                    cy="12"
                    r="1"
                    fill="currentColor"
                  />

                  <path d="M9 16c1.7 1 4.3 1 6 0"/>
                  <path d="M12 6l1-4 4 1"/>
                  <circle
                    cx="18"
                    cy="3"
                    r="1.5"
                  />
                  <path d="M5.5 10L3 8.5"/>
                  <path d="M18.5 10L21 8.5"/>
                </svg>

              }

              <!-- TWITCH -->

              @case ('twitch') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M4 2h18v13l-5 5h-4l-3 3H7v-3H3V5zm2 3v12h4v3l3-3h4l3-3V5zm5 3h2v6h-2zm5 0h2v6h-2z"
                  />
                </svg>

              }

              <!-- DISCORD -->

              @case ('discord') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M19.5 5.3A16 16 0 0 0 15.6 4l-.5 1a13.7 13.7 0 0 0-6.2 0l-.5-1a15.5 15.5 0 0 0-3.9 1.3C2 9 1.4 12.7 1.7 16.4a15.8 15.8 0 0 0 4.8 2.4l1.2-1.7c-.7-.3-1.4-.7-2-1.2l.5-.4c3.8 1.8 7.9 1.8 11.6 0l.6.4c-.7.5-1.4.9-2.1 1.2l1.2 1.7a15.8 15.8 0 0 0 4.8-2.4c.4-4.2-.7-7.8-2.8-11.1zM8.5 14.5c-1.1 0-2-1-2-2.2s.9-2.2 2-2.2 2 1 2 2.2-.9 2.2-2 2.2zm7 0c-1.1 0-2-1-2-2.2s.9-2.2 2-2.2 2 1 2 2.2-.9 2.2-2 2.2z"
                  />
                </svg>

              }

              <!-- WHATSAPP -->

              @case ('whatsapp') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M12 2a9.8 9.8 0 0 0-8.4 14.8L2 22l5.4-1.5A10 10 0 1 0 12 2zm0 18a8 8 0 0 1-4.1-1.1l-.3-.2-3.2.9.9-3.1-.2-.3A8 8 0 1 1 12 20zm4.4-6c-.2-.1-1.4-.7-1.6-.8-.2-.1-.4-.1-.6.1-.2.3-.6.8-.8 1-.1.2-.3.2-.5.1-.2-.1-1-.4-1.9-1.2-.7-.6-1.2-1.4-1.3-1.6-.1-.2 0-.4.1-.5l.4-.5.3-.5c.1-.2 0-.4 0-.5l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3 4.9 4.2.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.4-.6 1.6-1.1.2-.5.2-1 .2-1.1 0-.1-.2-.2-.4-.3z"
                  />
                </svg>

              }

              <!-- NEXTDOOR -->

              @case ('nextdoor') {

                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M3 10l9-7 9 7"
                  />
                  <path
                    d="M5 9v11h5v-6h4v6h5V9"
                  />
                  <path
                    d="M8 7V4h3"
                  />
                </svg>

              }

              <!-- YELP -->

              @case ('yelp') {

                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M11 2c-.7 0-1.2.4-1.3 1.1l-.8 7.2c-.1.8.8 1.3 1.4.8l4.5-5.6c.5-.6.3-1.4-.4-1.8L11.8 2.2A1.6 1.6 0 0 0 11 2zm5.5 8.7-4.4 2.1c-.7.3-.7 1.3 0 1.6l5 1.5c.7.2 1.4-.2 1.5-.9l.4-2.8c.1-.8-.6-1.5-1.4-1.4zm-9 1.6-4.2-2.4c-.7-.4-1.5 0-1.7.8L1 13.4c-.2.8.4 1.5 1.2 1.5l5-.8c.8-.1 1-1.3.3-1.8zm1.8 3.3-3.6 3.5c-.6.6-.4 1.5.3 1.8l2.7 1.1c.7.3 1.4-.1 1.6-.8l.8-4.8c.1-.9-1.1-1.4-1.8-.8zm4.3.5c-.7-.4-1.5.2-1.3 1l1.5 4.7c.2.8 1.1 1.1 1.7.6l2.2-1.8c.6-.5.5-1.4-.1-1.8z"
                  />
                </svg>

              }

              <!-- GOOGLE BUSINESS -->

              @case ('googlebusiness') {

                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M4 10v10h16V10"
                  />
                  <path
                    d="M3 10l2-6h14l2 6"
                  />
                  <path
                    d="M3 10c0 1.7 1.3 3 3 3s3-1.3 3-3"
                  />
                  <path
                    d="M9 10c0 1.7 1.3 3 3 3s3-1.3 3-3"
                  />
                  <path
                    d="M15 10c0 1.7 1.3 3 3 3s3-1.3 3-3"
                  />
                  <path
                    d="M9 20v-5h6v5"
                  />
                </svg>

              }

              <!-- OTHER -->

              @default {

                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M10 13a5 5 0 0 0 7.07.07l2-2a5 5 0 0 0-7.07-7.07l-1.15 1.15"
                  />

                  <path
                    d="M14 11a5 5 0 0 0-7.07-.07l-2 2A5 5 0 0 0 12 20l1.15-1.15"
                  />
                </svg>

              }

            }

          </span>

          <span class="social-name">
            {{ social.name }}
          </span>

        </a>

      }

    </div>

  </section>

}